import { environment } from "../../environment";

export const API_ENDPOINTS = {
    PAGES: "/.rest/delivery/pages${path}",
    NAVIGATION: "/.rest/delivery/navigation",
    BRANDS: "/.rest/delivery/brands",
    CATEGORIES: "/.rest/delivery/categories",
    PRODUCTS: "/.rest/delivery/products",
    PRODUCT_DECORATION: "/.rest/delivery/product-decoration",
    EXTERNAL_CATEGORIES: "/.rest/external/${source}/categories/${categoryId}",
    EXTERNAL_PRODUCTS: "/.rest/external/${source}/categories/${categoryId}/products",
    EXTERNAL_PRODUCT: "/.rest/external/${source}/products/${productId}",
    TEMPLATE_ANNOTATIONS: "/.rest/template-annotations/v1${path}",
    SITE_INFO: "/.rest/siteInfo/website${path}",
};

export const getApiEndpoint = (endpoint, params = {}) => {
    if (!API_ENDPOINTS[endpoint]) {
        console.warn("Endpoint is not configured");
        return null;
    }

    const { queryParams, pathParams } = params;

    let e = environment.MAGNOLIA_BASE_URL + API_ENDPOINTS[endpoint];

    if (pathParams) {
        for (const [key, value] of Object.entries(pathParams)) {
            e = e.replace(new RegExp(`\\$\\{${key}\\}`), value);
        }
    }

    if (queryParams) {
        const qpFiltered = Object.fromEntries(Object.entries(queryParams).filter(([key, value]) => key && value));
        const qp = new URLSearchParams(qpFiltered).toString();

        if (qp.length) {
            e = `${e}?${qp}`;
        }
    }

    return e;
};
